module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('b-container', {
    attrs: {
      "fluid": ""
    }
  }, [(_vm.user) ? _c('b-row', [_c('b-col', [_c('h4', {
    staticClass: "card-title text-left mt-2"
  }, [_vm._v("Votre profil")]), _vm._v(" "), _c('p', {
    staticClass: "text-left"
  }, [_vm._v("\n        Votre email : " + _vm._s(_vm.user.email)), _c('br'), _vm._v(" "), _c('b-button', {
    attrs: {
      "variant": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.$auth.logout()
      }
    }
  }, [_vm._v("Se déconnecter")])], 1)])], 1) : _vm._e(), _vm._v(" "), (!_vm.user) ? _c('b-row', [_c('b-col', [_c('h4', {
    staticClass: "card-title text-left mt-2"
  }, [_vm._v("Vous n'êtes pas connecté")]), _vm._v(" "), _c('p', {
    staticClass: "text-left"
  }, [_c('b-button', {
    attrs: {
      "variant": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.$root.$emit('bv::show::modal', 'modallogin')
      }
    }
  }, [_vm._v("Se connecter")])], 1)])], 1) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-769f5198","transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/profile.vue
// module id = ZFjq
// module chunks = 1